import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background: #FFF;
  border-radius: 6px;
  border: 1px solid #EFF0F6;
  position: relative;
  padding: 0 .5rem;
  display: flex;
  align-items:center;
  justify-content: center;
  gap: .5rem;
  flex-direction: column;
`;
export const ContentButtons = styled.div`
  display: flex;
  align-items:center;
  justify-content: flex-start;
  background: transparent;
  /* position: absolute; */
  width: 100%;
  top: 0;
  right: .6rem;
  padding: .5rem;
  select {
    cursor: pointer;
    border: none;
    color: #00000050;
  }
  label {
    text-align: left;
    width: 90%;
    font-weight: 500;
  }
`;